"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function IosGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M.207 5.179a.49.49 0 11.682-.688.49.49 0 01-.343.825.462.462 0 01-.34-.137zm0 1.178h.702v5.728H.163l.044-5.728zM3.8 11.707a3.299 3.299 0 01-1.252-1.419 4.992 4.992 0 01-.422-2.164c-.019-.75.134-1.494.447-2.175a3.299 3.299 0 011.252-1.418c.579-.34 1.242-.511 1.914-.491a3.564 3.564 0 011.92.49c.546.341.981.834 1.25 1.42.302.683.445 1.427.418 2.174.02.75-.13 1.495-.437 2.18a3.323 3.323 0 01-1.247 1.418 3.52 3.52 0 01-1.919.49 3.55 3.55 0 01-1.924-.505zm3.436-.614a2.72 2.72 0 00.982-1.187 4.33 4.33 0 00.353-1.782 4.266 4.266 0 00-.353-1.807 2.606 2.606 0 00-2.499-1.63 2.626 2.626 0 00-2.498 1.591 4.29 4.29 0 00-.354 1.846 4.26 4.26 0 00.354 1.801c.206.482.547.895.982 1.188.451.286.977.43 1.511.417a2.68 2.68 0 001.522-.437zM11.654 11.943c-.4-.162-.75-.426-1.016-.766a2.101 2.101 0 01-.427-1.163v-.079h.75v.079c.033.293.153.57.344.795.207.235.47.414.766.52a2.99 2.99 0 001.11.186c.37.01.738-.054 1.084-.186a1.66 1.66 0 00.717-.525c.17-.234.259-.516.255-.805a1.183 1.183 0 00-.402-.933 3.057 3.057 0 00-1.326-.56l-.869-.19a3.627 3.627 0 01-1.678-.786 1.806 1.806 0 01-.56-1.37 1.9 1.9 0 01.354-1.119c.25-.339.59-.602.981-.76A3.318 3.318 0 0113.131 4a3.23 3.23 0 011.375.28c.388.167.726.433.981.77.236.34.37.74.383 1.153v.074h-.765V6.21a1.62 1.62 0 00-.324-.805 1.723 1.723 0 00-.693-.52 2.415 2.415 0 00-.981-.186 2.601 2.601 0 00-1.011.181c-.265.1-.498.27-.673.491a1.217 1.217 0 00-.255.79 1.137 1.137 0 00.402.903c.374.28.808.468 1.267.55l.873.192a3.794 3.794 0 011.753.78 1.84 1.84 0 01.535 1.39c.009.422-.115.838-.353 1.187a2.21 2.21 0 01-.982.776c-.48.196-.994.291-1.512.28a3.882 3.882 0 01-1.497-.275z"
  }));
}

IosGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
IosGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = IosGreyOutline;
exports["default"] = _default;